import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'
const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 获取表单字段
export const getFiled = (data?: any) =>
  request.post('/paas/column/list_for_process', data, jsonHeaderConfig)
// 保存
export const saveFlow = (data?: any) =>
  request.post('/paas/process/template/config/create', data, jsonHeaderConfig)
// 更新
export const updateFlow = (data?: any) =>
  request.post('/paas/process/template/config/update', data, jsonHeaderConfig)
// 删除
export const deleteFlow = (data?: any) =>
  request.post('/paas/process/template/config/delete', data, jsonHeaderConfig)
// 启用 禁用
export const enableFlow = (data?: any) =>
  request.post('/paas/process/template/config/change_status', data, jsonHeaderConfig)

// 获取模板下所有的配置
export const getFlowTemplateList = (data?: any) =>
  request.post('/paas/process/template/config/list', data, jsonHeaderConfig)

// 创建模板
export const createFlowTemplate = (data?: any) =>
  request.post('/paas/process/template/create', data, jsonHeaderConfig)

// 查询是否存在审批流程模板
export const checkTemplateExists = (data?: any) =>
  request.post('/paas/process/template/check_template_exists', data, jsonHeaderConfig)

// 获取默认配置
export const getDefaultApprovalConfig = (data?: any) =>
  request.post('/paas/process/template/config/get_default_approval_config', data, jsonHeaderConfig)

// 通过Id获取配置
export const getConfigById = (data?: any) =>
  request.post('/paas/process/template/config/get', data, jsonHeaderConfig)

// 查询是否已存在已启用的配置
export const checkEnableConfig = (data?: any) =>
  request.post('/paas/process/template/config/check_enable_config', data, jsonHeaderConfig)

// 流程模板列表
export const getTemplatePage = (data?: any) =>
  request.post('/paas/process/template/page', data, jsonHeaderConfig)

// 创建业务流程模板
export const createBusinessTemplate = (data?: any) =>
  request.post('/paas/process/template/create', data, jsonHeaderConfig)

// 修改业务流程模板
export const updateBusinessTemplate = (data?: any) =>
  request.post('/paas/process/template/update', data, jsonHeaderConfig)

// 删除业务流程模板
export const deleteBusinessTemplate = (data?: any) =>
  request.post('/paas/process/template/delete', data, jsonHeaderConfig)

// 代办详情
export const getFlowDetail = (data: any) =>
  request.post('/paas/process/task/detail', data, jsonHeaderConfig)

// 根据ID获取业务流程基础信息
export const getFlowInfo = (data: any) =>
  request.post('/paas/process/template/get', data, jsonHeaderConfig)

// 流程代办列表
export const getProcessTask = (data: any) =>
  request.post('/paas/process/task/page', data, jsonHeaderConfig)

// 流程代办列表获取查询参数
export const getQueryParam = (data: any) =>
  request.post('/paas/process/task/get_query_param', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })

// 查询是否重复
export const checkRepeatProcess = (data: any) =>
  request.post('/paas/process/template/check_repeat_process', data, jsonHeaderConfig)

// 流程执行
export const taskActionTo = (data: any) =>
  request.post('/paas/process/task/action/do', data, jsonHeaderConfig)

// 查询是否配置了流程
export const getFlowByDataId = (data: any) =>
  request.post('/paas/process/task/query_process_by_data', data, jsonHeaderConfig)

// 获取触发的行为
export const getTriggerActions = (tableCode: any) =>
  request.post(
    '/paas/process/template/config/get_process_trigger_actions',
    { value: tableCode },
    jsonHeaderConfig
  )

// 获取子流程列表
export const getProcessList = () =>
  request.post('/paas/process/template/list_enable_business_process', {}, jsonHeaderConfig)

// 获取子流程列表
export const getMappingData = (params: any) =>
  request.post('/paas/columnData/process/get_mapping_data', params, jsonHeaderConfig)

// ERP查询字段配置
export const getErpFiled = (data?: any) =>
  request.post('/paas/column/list_column_for_npa', data, jsonHeaderConfig)
